App.namespace.wrap('components.room_cards_carousel_tabs', (options = {}) => {
  let selectedTabIndex = 0;
  const $tabsPills = $('.c-pill--room-cards-carousel');
  const $tabsContainer = $('.c-room-cards-carousels');

  $tabsPills.click(function (e) {
    selectedTabIndex = $(e.currentTarget).data('index');
    $tabsContainer.children().addClass('hidden');
    $(`.c-room-cards-carousel-${selectedTabIndex}`).removeClass('hidden');
    $('.ds-pill--selected').removeClass('ds-pill--selected');
    $(e.currentTarget).addClass('ds-pill--selected');
    App.components.room_cards_carousel({ updateArrowsOnly: true });
  });
});
